// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__NWZmA","requiredAsterisk":"Info_requiredAsterisk__3l6Mz"};